// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"8e9b2a8622754063e737","418":"2f9e5d3c1823d8a2511e","661":"d32de4dd45f6cd00c8a8"}[chunkId] + ".bundle.js";
};